// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"5021":"41702b1578edcde86430","5712":"6e045ed3b74d14571744"}[chunkId] + ".css";
};